module.exports = __webpack_public_path__ + "img/solar-system.b51428a2.svg";